
/**
 * Fee Calculation Constants
 * Single source of truth for all fee percentages and amounts
 */

/* @preserve-code */
// Standard fees for card payments
export const STRIPE_PERCENT_FEE = 0.029; // 2.9%
export const STRIPE_FIXED_FEE = 0.30; // $0.30
export const KEEP_MORE_PERCENT_FEE = 0.01; // 1%

// For bank accounts (ACH), fees are lower
export const BANK_STRIPE_PERCENT_FEE = 0.008; // 0.8% for ACH
export const BANK_STRIPE_FIXED_FEE = 0.00; // No fixed fee for ACH
export const BANK_STRIPE_MAX_FEE = 5.00; // $5 maximum fee for ACH
/* @end-preserve */

// ACH Fee Storage Constants
export const ACH_FEE_STORAGE_KEY = 'keepmore_ach_fee_setting';
export const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
